<template>
  <div :class="['budget-card', typeClass]">
    <div class="budget-icon">
      <i :class="`icon text-white fa-solid fa-${icon}`"></i>
    </div>
    <div class="budget-content">
      <span class="budget-label">{{ label }}</span>
      <span class="budget-amount" :class="amountClass">{{ amount }}</span>
      <span class="budget-description">{{ description }}</span>
    </div>
    <div :class="['budget-pulse', pulseClass]"></div>
  </div>
</template>

<script>
export default {
  name: "BudgetCard",
  props: {
    typeClass: String,
    icon: String,
    label: String,
    amount: [String, Number],
    description: String,
    pulseClass: String,
    amountClass: String,
  },
};
</script>
<style lang="scss" scoped>
@import url('@/assets/styles/components/rainInfo.scss');
</style>